import React, { useEffect, useState } from "react";
import "./Sleepingtracker.css";
import { sleepimg } from "assets/icons";
import useFullPageLoader from "common/UseFullPageLoader";
import { sleepTrackingListApi } from "services/sleepTracking";
import { formatRelativeDate, formatTime } from "utils/common";
import { dateFormatWithTime } from "utils/dateFormat";

const Sleepingtracker = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [trackingList, setTrackingList] = useState([]);
  const [meta, setMeta] = useState({});

  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await sleepTrackingListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setTrackingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="sleepingtracker_parent">
        <div className="sleepingtracker_wraper">
          <div className="avg_sleep_hrs">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">
                <div className="sleepingtracker_heading">
                  <h5 className="">Average Sleep time per day</h5>
                  <div className="sleeping_hrs">
                    <p>{ formatTime(Math.ceil(meta?.totalDurationAverage)) }</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* First */}
          <div className="sleeping_hrs_wraper row">
            {
              trackingList?.map((tracking, k) => {
                return <div className="col-sm-12 col-md-6 col-lg-4" key={k}>
                  <div className="hrs_cards">
                    <div className="card_top_side">
                      <p className="today">{formatRelativeDate(tracking?._id)}</p>
                      <p className="hours">Total Average {formatTime(Math.ceil(tracking?.totalDurationAverage))} </p>
                    </div>

                    {
                      tracking?.sleepTrackings?.map((ele, i) => {
                        return <div className="hrs_cards_wraper" key={i}>
                          <div className="cards__inside_lft">
                            <img src={sleepimg} />
                          </div>

                          <div className="cards__inside_rgt">
                            <div className="hrs_sleeping">
                              <p className="all_time_sleep">{formatTime(Math.ceil(ele?.totalDuration))}</p>
                              <p className="alldates">
                                <span className="date">{dateFormatWithTime(ele.createdAt)}</span>
                              </p>
                            </div>
                          </div>
                        </div>
                      })
                    }
                  </div>
                </div>
              })
            }
          </div>
        </div>
      </div>
    </>
  );
};

export default Sleepingtracker;
